import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import { Block } from "./components/Block";
export var Blocks = /*#__PURE__*/memo(function (_ref) {
  var blocks = _ref.blocks,
    data = _ref.data;
  return /*#__PURE__*/React.createElement(React.Fragment, null, blocks.map(function (block) {
    return /*#__PURE__*/React.createElement(Block, _extends({
      key: "".concat(block.type, ":").concat(block.title)
    }, block.type === 'links' ? data[block.type][block.title] : data[block.type]));
  }));
});